import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../../vme-common.module';
import { VMEComponentsModule } from '../../../vme-components.module';
import { VmeDirectivesModule } from '../../../vme-directives.module';
import { VmePipesModule } from '../../../vme-pipes.module';
import { SupplierAvailabilityViewComponent } from './supplier-availability-view.component';
import { ToastModule } from 'primeng/toast';
import { RedirectTermConditionGuard } from 'src/app/guards/redirect-term-condition.guard';

const routes: Routes = [
  {
    path: '',
    component: SupplierAvailabilityViewComponent,
    data: { title: 'Supplier Availability' },
    canActivate: [RedirectTermConditionGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SupplierAvailabilityViewRoutingModule {}

@NgModule({
  imports: [
    SupplierAvailabilityViewRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
    ToastModule,
  ],
  declarations: [SupplierAvailabilityViewComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SupplierAvailabilityViewModule {}
